import React from 'react'
import { Button, Card, Tag, Typography } from 'antd'
import { AppstoreOutlined, DashboardOutlined, RightOutlined } from '@ant-design/icons'

const { Title, Paragraph, Text } = Typography

const AIC_DASHBOARD_PATH = '/portal/aic-dashboard/overview'
const AIC_SKILL_MARKET_PATH = '/portal/profile?tab=skillmarket'

export default function AicDataAssetTab({ onTabSwitch, history }) {
    const navigate = (event, path, tab) => {
        event.preventDefault()
        if (tab && onTabSwitch) {
            onTabSwitch(tab)
            return
        }
        if (history?.push) {
            history.push(path)
            return
        }
        window.location.assign(path)
    }

    return (
        <div className="profile-aic-assets profile-aic-entry-page">
            <section className="profile-aic-assets-hero">
                <Tag color="cyan">AIC · All In Context</Tag>
                <Title level={1}>AIC 数据资产</Title>
                <Paragraph>通过 AIC 看板查看数据资产运行状态，或前往 Skill 市场安装 AIC Skill，在 Codex 中完成登记、上传、查询和规则配置。</Paragraph>
            </section>

            <section className="profile-aic-entry-grid" aria-label="AIC 数据资产入口">
                <Card bordered={false} className="profile-aic-entry-card">
                    <div className="profile-aic-entry-icon profile-aic-entry-icon-dashboard" aria-hidden="true"><DashboardOutlined /></div>
                    <div className="profile-aic-entry-content">
                        <Title level={3}>AIC 看板</Title>
                        <Text type="secondary">查看数据源健康状态、最新数据日期、质量预警和异常详情。</Text>
                    </div>
                    <Button
                        type="primary"
                        size="large"
                        block
                        href={AIC_DASHBOARD_PATH}
                        onClick={event => navigate(event, AIC_DASHBOARD_PATH)}
                        aria-label="进入 AIC 看板"
                    >
                        进入 AIC 看板 <RightOutlined />
                    </Button>
                </Card>

                <Card bordered={false} className="profile-aic-entry-card">
                    <div className="profile-aic-entry-icon profile-aic-entry-icon-skill" aria-hidden="true"><AppstoreOutlined /></div>
                    <div className="profile-aic-entry-content">
                        <Title level={3}>AIC Skill 下载</Title>
                        <Text type="secondary">前往 Skill 市场安装 AIC 数据资产 Skill，使用对话完成完整操作。</Text>
                    </div>
                    <Button
                        size="large"
                        block
                        href={AIC_SKILL_MARKET_PATH}
                        onClick={event => navigate(event, AIC_SKILL_MARKET_PATH, 'skillmarket')}
                        aria-label="前往 Skill 市场下载 AIC Skill"
                    >
                        前往 Skill 市场 <RightOutlined />
                    </Button>
                </Card>
            </section>
        </div>
    )
}

/*
 * 旧版 AIC 数据资产多步页面按产品要求暂时停用并完整保留。
 * 如需恢复，可从下方旧版实现中取回登记、上传和查询流程。
 *
 * import React, { useEffect, useMemo, useState } from 'react'
 * import { Alert, Badge, Button, Card, Empty, Space, Spin, Tag, Typography, message } from 'antd'
 * import { ArrowDownOutlined, CodeOutlined, DashboardOutlined, ReloadOutlined, SafetyOutlined, SearchOutlined } from '@ant-design/icons'
 * import { getAicProfileProjects } from '../../request'
 * import AicCodexOnboardingTab from './AicCodexOnboardingTab'
 * import { VIBE_DATASET_BOOTSTRAP_PROMPT } from './vibeDatasetBootstrapPrompt'
 *
 * const { Title, Text, Paragraph } = Typography
 *
 * const STAGE_META = {
 *     registered: { label: '已登记', color: 'blue' },
 *     ready: { label: '待首次接入', color: 'orange' },
 *     published: { label: '已发布', color: 'green' },
 *     failed: { label: '接入异常', color: 'red' },
 * }
 *
 * function getProjects(value) {
 *     return Array.isArray(value) ? value : (value?.list || value?.data || [])
 * }
 *
 * function getStage(project) {
 *     if (project?.status === 'failed') return STAGE_META.failed
 *     if (project?.dataset?.lastSuccessfulUploadAt || project?.lastSuccessfulUploadAt) return STAGE_META.published
 *     if (project?.dataset || project?.isDataset || project?.projectKind === 'dataset') return STAGE_META.ready
 *     return STAGE_META.registered
 * }
 *
 * function copyText(value) {
 *     if (!value) {
 *         message.warning('暂无可复制内容')
 *         return
 *     }
 *     if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
 *         navigator.clipboard.writeText(value)
 *             .then(() => message.success('已复制到剪贴板'))
 *             .catch(() => message.warning('复制失败，请手动复制'))
 *         return
 *     }
 *     message.warning('当前浏览器不支持自动复制，请手动复制')
 * }
 *
 * function AicProjectCard({ project, onDashboard, onQuery }) {
 *     const stage = getStage(project)
 *     const dataset = project.dataset || project
 *     return (
 *         <div className="profile-aic-project-row">
 *             <div className="profile-aic-project-head">
 *                 <div>
 *                     <Title level={4}>{project.projectName || project.name || '-'}</Title>
 *                     <Text type="secondary">{dataset.ownerDepartmentName || project.businessSubject || '未设置归属部门'}</Text>
 *                 </div>
 *                 <Badge color={stage.color} text={stage.label} />
 *             </div>
 *             <Space wrap size={[8, 4]}>
 *                 {dataset.sensitivityLevel && <Tag color="purple">{dataset.sensitivityLevel}</Tag>}
 *                 {dataset.updateFrequency && <Tag>{dataset.updateFrequency}</Tag>}
 *                 <Text type="secondary">最近成功发布：{dataset.lastSuccessfulUploadAt || '从未上传过数据'}</Text>
 *             </Space>
 *             <div className="profile-aic-project-actions">
 *                 <Button type="link" icon={<SearchOutlined />} onClick={onQuery}>获取查询提示词</Button>
 *                 <Button type="link" icon={<DashboardOutlined />} onClick={() => onDashboard(project.id)}>查看数据看板</Button>
 *             </div>
 *         </div>
 *     )
 * }
 *
 * function LegacyAicDataAssetTab({ onTabSwitch, history }) {
 *     const [loading, setLoading] = useState(true)
 *     const [error, setError] = useState('')
 *     const [projects, setProjects] = useState([])
 *     const [activeStep, setActiveStep] = useState('register')
 *     const load = () => {
 *         setLoading(true)
 *         setError('')
 *         getAicProfileProjects({})
 *             .then(value => setProjects(getProjects(value)))
 *             .catch(() => setError('AIC 项目暂时无法读取，请稍后刷新'))
 *             .finally(() => setLoading(false))
 *     }
 *     useEffect(load, [])
 *     const hasProjects = projects.length > 0
 *     const dashboard = id => history?.push(`/portal/aic-dashboard/datasets/${encodeURIComponent(id)}`)
 *     const openQueryGuide = () => onTabSwitch?.('vibeprojects')
 *     const nextAction = useMemo(() => hasProjects ? '选择一个项目，在 Codex 中分析并确认数据后发布' : '在 Codex 中通过对话收集参数，完成数据资产登记', [hasProjects])
 *
 *     return (
 *         <div className="profile-aic-assets">
 *             <section className="profile-aic-assets-hero">
 *                 <Tag color="cyan">AIC · All In Context</Tag>
 *                 <Title level={1}>AIC 数据资产</Title>
 *                 <Paragraph>在 Codex 中分析、确认和发布业务数据。此页面用于查看状态和配置工作台，不直接创建项目或上传业务数据。</Paragraph>
 *                 <Alert type="info" showIcon icon={<SafetyOutlined />} message={`下一步：${nextAction}`} />
 *             </section>
 *             <section className="profile-aic-assets-flow" aria-label="AIC 使用流程">
 *                 <div className="profile-aic-flow-track">
 *                     {[
 *                         { label: '登记', target: 'aic-register', hint: '创建数据资产目录' },
 *                         { label: '上传', target: 'aic-upload', hint: '在 Codex 接入数据' },
 *                         { label: '查询', target: 'aic-query', hint: '选择项目开始问数' },
 *                     ].map((item, index) => <React.Fragment key={item.label}>
 *                         <Button type="text" className={`profile-aic-flow-item ${activeStep === item.target.replace('aic-', '') ? 'is-active' : ''}`} onClick={() => setActiveStep(item.target.replace('aic-', ''))} aria-current={activeStep === item.target.replace('aic-', '') ? 'step' : undefined}><span>{index + 1}</span><em>{item.label}<small>{item.hint}</small></em></Button>
 *                         {index < 2 && <i aria-hidden="true">→</i>}
 *                     </React.Fragment>)}
 *                 </div>
 *             </section>
 *             {activeStep === 'register' && <section id="aic-register" className="profile-aic-assets-section profile-aic-step-section">
 *                 <div className="profile-aic-assets-section-head"><div><Title level={2}>1. 登记 AIC 数据资产</Title><Text type="secondary">直接在 Codex 中对话提供业务信息，由 Codex 逐项追问、生成 Markdown 预览；确认后登记元数据。</Text></div><Tag color="blue">只登记目录，不上传数据</Tag></div>
 *                 <Card bordered={false} className="profile-aic-prompt-card">
 *                     <div className="profile-aic-prompt-head"><div><strong><CodeOutlined /> AIC 等级与项目登记提示词</strong><div><Text type="secondary">复制给 Codex 即可，通过对话收集参数，不强制提供 Markdown。</Text></div></div><Button type="primary" icon={<CodeOutlined />} onClick={() => copyText(VIBE_DATASET_BOOTSTRAP_PROMPT)}>复制登记提示词</Button></div>
 *                     <pre>{VIBE_DATASET_BOOTSTRAP_PROMPT}</pre>
 *                 </Card>
 *             </section>}
 *             {activeStep === 'upload' && <section id="aic-upload" className="profile-aic-assets-section profile-aic-step-section">
 *                 <div className="profile-aic-assets-section-head"><div><Title level={2}>2. 上传数据</Title><Text type="secondary">复用原“AIC 数据上传”工作台，页面只提供引导，实际分析和上传由 Codex 完成。</Text></div><Space><Tag color="green">ZIP：执行一次</Tag><Tag color="orange">提示词：按说明执行</Tag></Space></div>
 *                 <AicCodexOnboardingTab onTabSwitch={onTabSwitch} />
 *             </section>}
 *             {activeStep === 'query' && <section id="aic-query" className="profile-aic-assets-section profile-aic-step-section">
 *                 <div className="profile-aic-assets-section-head"><div><Title level={2}>3. 查询项目数据</Title><Text type="secondary">先选择一个已登记的 AIC 项目，再在 Codex 中新建查询会话。</Text></div><Button icon={<ReloadOutlined />} onClick={load}>刷新状态</Button></div>
 *                 {error && <Alert type="warning" showIcon message={error} />}
 *                 <Spin spinning={loading}>{hasProjects ? <div className="profile-aic-project-grid">{projects.map(project => <AicProjectCard key={project.id} project={project} onDashboard={dashboard} onQuery={openQueryGuide} />)}</div> : !loading && <Empty description="还没有 AIC 数据资产"><Button type="primary" icon={<CodeOutlined />} onClick={() => copyText(VIBE_DATASET_BOOTSTRAP_PROMPT)}>复制 Codex 登记提示词</Button></Empty>}</Spin>
 *                 <Card bordered={false} className="profile-aic-query-guide-card"><div><strong><SearchOutlined /> 项目查询提示词</strong><p>在项目页点击“申请和授权有啥用？”，复制弹窗中的完整提示词到 Codex。申请/授权用于控制谁可以查询或上传；授权通过后需重新执行提示词刷新项目范围。</p></div><Button icon={<ArrowDownOutlined />} onClick={() => onTabSwitch?.('vibeprojects')}>打开项目与授权</Button></Card>
 *             </section>}
 *         </div>
 *     )
 * }
 */
